import { styled } from '@mui/material/styles';
import { Placeholder } from '@/components/base/placeholder';
import { Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PREFIX = 'index';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
  },
}));

export default function H5NotSupported() {
  const navigate = useNavigate();

  return (
    <Root className={classes.root}>
      <Placeholder title="暂未适配移动端，请在电脑端访问。">
        <Box marginTop={1}>
          <Button variant="outlined" onClick={() => navigate('/home')}>
            继续前往
          </Button>
        </Box>
      </Placeholder>
    </Root>
  );
}
